<script setup>
import {computed, onMounted, ref, watch} from "vue";
import store from "@/store";
import {game} from "@/utils/config";
import LoginComponents from "@/components/login/LoginComponents.vue";
import axiosApi from "@/utils/axiosApi";
import router from "@/router";

const type = computed(() => {
  let type = store.state.coupon;
  if (type) {
    return game[type]
  }
  return {}
});
const showLogin = ref(false);
const account = computed(() => {
  return store.state.account;
});
const scroll = ref();
watch(account, (to) => {
  if (Object.keys(to).length < 1) {
    showLogin.value = true;
    return;
  }
  getOrder(1);
})
onMounted(async () => {
  store.commit('getCoupon');
  await store.dispatch('getAccounts')
  document.title = type.value.title;
  // await getOrder(1);
})
const page = ref(1)
const lastPage = ref(1)
const orderLst = ref([])
const getOrder = p => {
  showLogin.value = false;
  if (Object.keys(account.value).length < 1) return;
  page.value = p || 1;
  new axiosApi({
    encode: "coupon",
    method: "life/orderLst",
    body: {
      cust_id: account.value.cust_id,
      type: `${type.value.coupon}-${type.value.plate}`,
      page: page.value
    }
  }).send(res => {
    if (res.message.code !== "000") return
    const result = res.data.data.map(item => {
      item.goodsItems = item.goodsItems.remarks ? JSON.parse(item.goodsItems.remarks) : {};
      return item
    });
    orderLst.value = p === 1 ? result : orderLst.value.concat(result);
    lastPage.value = res.data.last_page;
  })
}
const backHome = () => {
  router.replace({name: 'home'})
}

const onScrollbar = (refs) => {
  let warp = refs.wrapRef;
  const poor = warp.scrollHeight - warp.clientHeight;
  if (poor === parseInt(warp.scrollTop) || poor === Math.ceil(warp.scrollTop) || poor === Math.floor(warp.scrollTop)) {
    console.log(page.value, lastPage.value)
    if (page.value < lastPage.value) {
      getOrder(page.value + 1)
    }
  }
}
</script>

<template>
  <div class="order-view page-pid" :class="type.plate" :style="type.style">
    <div class="header">
      <div class="header-left" @click="backHome">
        <el-icon>
          <ArrowLeft/>
        </el-icon>
      </div>
      <div class="header-left">兑换记录</div>
      <div class="header-left"></div>
    </div>
    <el-scrollbar class="order-lst" ref="scroll" @scroll="onScrollbar(scroll)">
      <el-card class="order-items" shadow="never" v-for="order in orderLst" :key="order.id">
        <template #header>
          <div class="order-items-header">
            <div class="order-sn">
              订单编号：{{ order.ordersn }}
            </div>
            <div class="order-state">
              <div :class="`order-state-item-${order.state === 1?'success':'cancel'}`">
                {{ order.state_text }}
              </div>
            </div>
          </div>
        </template>
        <div class="order-items-body">
          <div class="order-items-body-left">
            <el-image :src="type.productImgAvatar" class="order-items-body-left-img"/>
            <div class="order-items-body-left-title"><b>{{ order.goodsItems.number }}</b>{{ type.unit }}</div>
          </div>
          <div class="order-items-body-right">
            <h4 class="order-product-name">【{{ type.name }}】{{ order.goodsItems.number }}{{ type.unit }}</h4>
            <div class="order-items-body-right-content">
              <span>支付里程：</span>{{ order.miles }}里程
            </div>
            <div class="order-items-body-right-content">
              <span>下单时间：</span>{{ order.create_time }}
            </div>
            <div class="order-items-body-right-content">
              <span>充值账户：</span>{{ order.mobile }}
            </div>
          </div>
        </div>
      </el-card>
    </el-scrollbar>
  </div>
  <login-components :show-login="showLogin" v-if="showLogin"/>
</template>

<style scoped lang="less">
.order-view {
  //background: url("@/assets/images/dzpd/order-bg.png") no-repeat;
  &.dzpd {
    background: url("@/assets/images/dzpd/order-bg.png") no-repeat;
    background-size: 100% auto;
  }

  &.qyjsq {
    background: url("@/assets/images/qyjsq/order-bg.png") no-repeat;
    background-size: 100% auto;

    &.order-items-body-left-title {
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
    }
  }

  height: 100vh;
  box-sizing: border-box;

  .header {
    height: 40px;
    line-height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.2rem;
    margin-left: 15px;
  }

  .order-lst {
    height: calc(100vh - 60px);
    padding: 10px 15px;


    .order-items {
      margin-bottom: 15px;
      background: #ffffff url("@/assets/images/order-body.png") no-repeat right bottom;
      background-size: 50px;

      /deep/ .el-card__header {
        padding: 10px;
      }

      .order-items-header {

        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: .8rem;

        .order-state-item-success {
          color: var(--el-color-warning);
        }

        .order-state-item-cancel {
          color: var(--el-color-info);
        }
      }

      .order-items-body {
        display: flex;

        .order-items-body-left {
          flex-basis: 100px;
          width: 100px;
          margin-right: 8px;
          position: relative;

          .order-items-body-left-title {
            position: absolute;
            bottom: 10px;
            left: 5px;
            background: var(--view-product-value-background-color);
            text-align: center;
            line-height: 1.75;
            padding-left: 10px;
            padding-right: 10px;
            border-radius: 45px;
            color: var(--view-product-value-color);
            font-size: .75rem;
          }
        }

        .order-items-body-right {
          line-height: 1.75;

          .order-product-name {
            color: var(--view-exchange-color);
          }

          .order-items-body-right-content {
            font-size: .8rem;
          }
        }
      }
    }
  }
}
</style>
